export default (input, args) => {
    const plainText = input.replace(/<[^>]*>/g, '').trim()

    const max = args[0] !== undefined ? args[0] : Infinity

    return plainText.length <= max
}